import stylesOne from './tableStateOne.module.css';
import stylesTwo from './tableStateTwo.module.css';
import './tableStateOne.module.css';

export const PDPA = (
  <div style={{ overflowY: 'auto', height: '450px' }}>
    <h2 style={{ textAlign: 'center' }}>นโยบายความเป็นส่วนตัว (Privacy Notice)</h2>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;บริษัท ร้านร่าเริง จำกัด (ซึ่งต่อไปนี้จะเรียกว่า “บริษัทฯ” หรือ
      “apple sure ”) ผู้ถือครองเว็บไซต์ https://applehouseth.com
      เราถือปฎิบัติอย่างเคร่งครัดเรื่องความเป็นส่วนตัวของลูกค้าเป็นเรื่องสำคัญภายใต้
      พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
      โดยบริษัทมุ่งมั่นเป็นอย่างยิ่งที่จะคุ้มครองข้อมูลส่วนบุคคลของทุกท่านให้มีความปลอดภัย
      นโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ ให้ใช้กับข้อมูลส่วนบุคคลของลูกค้า หรือผู้รับบริการต่าง ๆ
      ของบริษัทฯ
      และให้ความสำคัญในการปกป้องรักษาข้อมูลเป็นเรื่องเกี่ยวกับความน่าเชื่อถือและความไว้วางใจ
      ความเป็นส่วนตัวของลูกค้าถือเป็นเรื่องสำคัญของบริษัทฯ ลูกค้ายินยอมและรับทราบว่าบริษัทฯ
      จะใช้ชื่อหรือข้อมูลอื่น ๆ ที่เกี่ยวข้องกับลูกค้า
      เพียงเฉพาะสำหรับกิจการที่ได้กำหนดไว้ในนโยบายความเป็นส่วนตัวนี้เท่านั้น บริษัทฯ
      จะจัดเก็บข้อมูลเพียงเท่าที่จำเป็นสำหรับการดำเนินการดังกล่าว และบริษัทฯ
      จะจัดเก็บเพียงข้อมูลที่เกี่ยวข้องกับการติดต่อทางธุรกิจระหว่างลูกค้ากับบริษัทฯ เท่านั้น
      บริษัทขอแจ้งและอธิบายให้ลูกค้าหรือผู้เข้าใช้งานเว็บไซต์และผู้เข้ารับบริการต่างๆ ณ
      ที่ทำการหรือสาขา ให้ทราบว่า บริษัทฯ เก็บรวบรวมข้อมูลส่วนบุคคลของท่านอย่างไร
      ข้อมูลใดบ้างที่บริษัทฯ จัดเก็บ มีวัตถุประสงค์ใดในการประมวลผลข้อมูล
      มีการเปิดเผยข้อมูลของท่านอย่างไร มาตราการการรักษาความปลอดภัย
      ความเป็นส่วนตัวของท่านขณะใช้งานบนเว็บไซต์ https://applehouseth.com
      และรวมถึงการใช้งานเว็บไซต์บนเครื่องมือสื่อสาร การใช้งานบนช่องทางมีเดียรูปแบบต่าง ๆ
      ช่องทางการเชื่อมต่อเข้าสู่เว็บไซต์อื่น ๆ การบำรุงรักษา ป้องกัน ปรับปรุง พัฒนาบริการใหม่ ๆ
      รวมถึงสิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล (ซึ่งต่อไปนี้จะเรียกว่า “นโยบาย”)
    </p>
    <p>
      {' '}
      ทั้งนี้ ท่านสามารถเข้าเว็บไซต์หรือแอปพลิเคชัน
      และเลือกชมสินค้าโดยไม่จำเป็นต้องให้ข้อมูลส่วนตัวใด ๆ
      ระหว่างที่ท่านเข้าสู่เว็บไซต์หรือแอปพลิเคชัน สถานะของท่านจะไม่เป็นที่เปิดเผย
      หากท่านไม่ยอมรับหรือไม่เห็นด้วยกับเงื่อนไขตามนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้
      โปรดหยุดการใช้งานหรือการเข้าถึงเว็บไซต์และ/หรือบริการของบริษัทฯ
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. กลุ่มหรือประเภทของบุคคลที่บริษัทฯ
      ทำการเก็บรวบรวมข้อมูลส่วนบุคคล<br></br>
      ภายใต้นโยบายคุ้มครองข้อมูลสวนบุคคลฉบับนี้กลุ่มหรือประเภทของบุคคลที่บริษัทฯ
      ทำการเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลประกอบด้วย ลูกค้า หมายถึง
      บุคคลที่ซื้อสินค้าและ/หรือใช้บริการจากบริษัทฯ
      และ/หรืออาจจะซื้อสินค้าและ/หรือใช้บริการจากบริษัทฯ หรือบุคคลอื่นใดที่มีลักษณะคล้าย เช่น
      ผู้ใช้บริการเว็บไซต์ ผู้ใช้บริการแอปพลิเคชัน หรือ
      ผู้ที่ติดต่อเพื่อขอรับข้อมูลหรือขอรับบริการจากบริษัทฯ ผู้ที่เกี่ยวข้องกับลูกค้า หมายถึง
      บุคคลที่เกี่ยวข้องหรือเป็นตัวแทนของลูกค้า เช่น ผู้บริหาร กรรมการ พนักงาน ตัวแทน หรือบุคลากรใด
      ๆ ของลูกค้าซึ่งเป็นนิติบุคคล รวมถึง ผู้ที่ข้อมูลส่วนบุคคลปรากฎในเอกสารต่าง ๆ
      ที่เกี่ยวข้องกับกระบวนการที่เกี่ยวข้อง อาทิ ผู้จัดการ ผู้สั่งซื้อ ผู้รับสินค้า
      และผู้สั่งจ่ายเช็ค และบุคคลที่ให้ความยินยอมโดยชอบธรรมทางกฎหมาย เช่น บิดา มารดา
      ผู้ปกครองหรือผู้แทนโดยชอบธรรมของผู้เยาว์ เป็นต้น
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. คำนิยามและความหมายของข้อมูลส่วนบุคคล<br></br>
      “ข้อมูลส่วนบุคคล” (Personal Data) หมายถึง ข้อมูลเกี่ยวกับบุคคล ซึ่งทำให้สามารถระบุตัวบุคคลนั้น
      ได้ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมข้อมูลนิติบุคคลและข้อมูลผู้ถึงแก่กรรมโดยเฉพาะ
      ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562<br></br>
      “เจ้าของข้อมูลส่วนบุคคล” หมายถึง
      บุคคลธรรมดาที่เป็นลูกค้าหรือผู้ที่เกี่ยวข้องกับลูกค้าของบริษัท
      ผู้ใช้บริการหรือผู้ใช้งานของเว็บไซต์ ตาม “ข้อตกลงและเงื่อนไขบริการ” ซึ่งอยู่ในฐานะ “ผู้ขาย”
      เป็นเจ้าของข้อมูลส่วนบุคคลตามนโยบายฉบับนี้ โดยอาจเรียกว่า “ผู้ใช้งาน” หรือ
      “ผู้ใช้งานแพลตฟอร์ม” หรือ “ท่าน”<br></br>
      “ผู้ควบคุมข้อมูลส่วนบุคคล” (Data controller) หมายถึง บริษัทฯ
      ซึ่งมีอำนาจตัดสินใจเกี่ยวกับข้อมูลส่วนบุคคลนั้น
      โดยได้รับข้อมูลส่วนบุคคลจากเจ้าของข้อมูลหรือให้บริการแก่เจ้าของข้อมูลหรือต้องทำหรือปฏิบัติตามสัญญากับเจ้าของข้อมูล
      ไม่ว่าจะทางตรงหรือทางอ้อมก็ตาม<br></br>
      “ผู้ควบคุมข้อมูลส่วนบุคคลร่วม” (Joint Data controller) หมายความว่า
      บุคคลหรือนิติบุคคลที่มีการแลกเปลี่ยน รับ โอน เปิดเผย หรือประมวลผลข้อมูลส่วนบุคคลระหว่างกัน
      โดยบุคคลหรือนิติบุคคลแต่ละรายต่างมีอำนาจตัดสินใจเก็บรวบรวม ใช้
      เปิดเผยข้อมูลส่วนบุคคลในส่วนหรือขอบเขตการให้บริการหรือข้อตกลงที่มีอยู่ระหว่างบุคคลหรือนิติบุคคลนั้นกับเจ้าของข้อมูลส่วนบุคคล
      ซึ่งในนโยบายนี้อาจเรียกว่า “พันธมิตร” (Partner)<br></br>
      “ข้อมูลส่วนบุคคลที่มีความอ่อนไหว” (Sensitive Personal Data) หมายถึง
      ข้อมูลที่ระบุตัวบุคคลได้ไม่ว่าทางตรงหรือทางอ้อมและเป็นข้อมูลที่กำหนดไว้ในพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
      พ.ศ. 2562 มาตรา 26 ได้แก่ ข้อมูลส่วนบุคคลเกี่ยวกับเชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง
      ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ความพิการ
      ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม ข้อมูลชีวภาพ
      หรือข้อมูลอื่นใดซึ่งกระทบต่อเจ้าของข้อมูลส่วนบุคคลในทำนองเดียวกันตามที่คณะกรรมการประกาศกำหนด
      <br></br>
      กรณีบริษัทฯ ได้รับสำเนาบัตรประจำตัวประชาชนของลูกค้า หรือบริษัทฯ
      นำข้อมูลของลูกค้าออกจากบัตรประจำตัวประชาชนด้วยวิธีการทางอิเล็กทรอนิกส์
      เพื่อวัตถุประสงค์ในการพิสูจน์ตัวตนของลูกค้าที่สมัครใช้บริการ และ/หรือทำธุรกรรมใด ๆ กับบริษัทฯ
      ข้อมูลที่ได้รับจะมีข้อมูลศาสนาด้วย ซึ่งถือว่าเป็นข้อมูลส่วนบุคคลที่มีความอ่อนไหว (Sensitive
      Personal Data) บริษัทฯ ไม่มีนโยบายจัดเก็บข้อมูลส่วนบุคคลที่มีความอ่อนไหวจากลูกค้า
      ยกเว้นในกรณีที่บริษัทฯ ได้รับความยินยอมจากลูกค้า ทั้งนี้ บริษัทฯ
      จะกำหนดวิธีการจัดการตามแนวทางปฏิบัติ และเป็นไปตามที่กฎหมายอนุญาต<br></br>
      ”เว็บไซต์” หมายถึง เว็บไซต์ ชื่อว่า “apple sure ” และ มีที่อยู่เว็บไซต์ที่
      https://applehouseth.com <br></br>
      “การประมวลผลข้อมูลส่วนบุคคล” หมายถึง การเก็บรวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคล<br></br>
      “ผู้เยาว์” หมายถึง บุคคลที่ยังไม่บรรลุนิติภาวะตามกฎหมาย<br></br>
      บุคคลไร้ความสามารถ หมายถึง บุคคลที่หย่อนความสามารถเพราะเป็นคนวิกลจริต โดยอาการ
      วิกลจริตนี้ต้องเป็นถึงขนาดที่ไม่สามารถจัดกิจการงานของตนเองได้เลย<br></br>
      บุคคลเสมือนไร้ความสามารถ หมายถึง บุคคลที่กายพิการหรือมีจิตฟั่นเฟือนไม่สมประกอบ
      หรือประพฤติสุรุ่ยสุร่ายเป็นอาจิณ หรือติดสุรายาเมา หรือมีเหตุอื่นทำนองเดียวกันนั้น
      จนไม่สามารถที่จะจัดกิจการงานของตนเองได้
      หรืออาจจัดกิจการงานของตนเองไปในทางที่เสื่อมเสียต่อทรัพย์สินของตนเองหรือครอบครัว<br></br>
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3. วิธีที่บริษัทฯ เก็บรวบรวมและรับข้อมูลส่วนบุคคลของท่าน
      <br></br>
      3.1 บริษัทฯ เก็บรวบรวมและรับข้อมูลส่วนบุคคลของท่านผ่านช่องทางต่าง ๆ ดังนี้<br></br>
      3.1.1 ข้อมูลส่วนบุคคลที่ท่านให้ไว้กับบริษัทฯ โดยตรง<br></br>
      แพลตฟอร์มของบริษัทในส่วนของเว็บไซต์
      โดยบริษัทเก็บรวบรวมข้อมูลส่วนบุคคลของผู้ใช้งานเมื่อท่านลงทะเบียนหรือทำการประเมิณราคาการรับซื้อเพื่อนัดหมายวันเวลาและสถานที่ขายแก่บริษัท
      “เว็บไซต์” ในฐานะผู้ขาย ตาม “ข้อตกลงและเงื่อนไขบริการ”<br></br>
      การสื่อสารหรือสนทนาช่องทางต่างๆ ระหว่างท่านและบริษัท เช่น การสนทนาผ่านข้อความสนทนา
      ที่บริษัทจัดให้มีขึ้น การสนทนาทางจดหมายอิเล็กทรอนิกส์ ทางโทรศัพท์
      หรือการสนทนาทางโปรแกรมหรือสื่อออนไลน์ต่างๆ ระหว่างท่านและบริษัท<br></br>
      เมื่อท่านส่งแบบฟอร์มหรือเอกสารใด ๆ ผ่านผลิตภัณฑ์และ/หรือบริการของบริษัทฯ
      รวมถึงแต่ไม่จำกัดเฉพาะ การลงทะเบียน การขอรับบริการ การกรอกแบบฟอร์ม แบบสอบถามหรือแบบสำรวจอื่น ๆ
      ที่ท่านได้ทำไว้หรือได้ให้ความสนใจ ทั้งนี้ ไม่ว่าจะเป็นการลงทะเบียนโดยผ่านเว็บไซต์
      สื่อสังคมออนไลน์ สถานที่จัดกิจกรรมหรือโดยช่องทางอื่นใดก็ตาม<br></br>
      เมื่อท่านแสดงเจตนาเพื่อขายสินค้าหรือใช้บริการจากบริษัทฯ เข้าทำสัญญาใดๆกับบริษัทฯ
      หรือส่งมอบเอกสารต่าง ๆ ซึ่งมีข้อมูลส่วนบุคคลปรากฏอยู่มาให้แก่บริษัทฯ<br></br>
      เมื่อท่านเข้าร่วมกิจกรรมทางการตลาด งานอีเวนต์ หรือกิจกรรมอื่น ๆ
      ที่จัดขึ้นโดยหรือในนามของบริษัทฯ เป็นต้น<br></br>
      เมื่อท่านใช้บริการ ผ่านเว็บไซต์ โดยบริษัทฯ
      อาจเก็บข้อมูลของท่านผ่านคุกกี้หรือเทคโนโลยีอื่นที่คล้ายกัน<br></br>
      ทั้งนี้ท่านจะต้องจัดส่งข้อมูลให้แก่บริษัทฯ ตัวแทนผู้รับมอบอำนาจของบริษัทฯ
      หรือจัดส่งเข้าสู่แพลตฟอร์มเท่านั้น และข้อมูลดังกล่าวจะต้องเป็นข้อมูลที่ ถูกต้องแท้จริง ครบถ้วน
      และไม่ทำให้เกิดความเข้าใจผิดใด ๆ ท่านจะต้องอัพเดทข้อมูลของท่านให้เป็นปัจจุบัน
      และแจ้งให้บริษัทฯทราบเกี่ยวกับการเปลี่ยนแปลงข้อมูลต่าง ๆ
      บริษัทฯสงวนสิทธิที่จะร้องขอเอกสารเพิ่มเติมเพื่อตรวจสอบยืนยันว่าข้อมูลที่ท่านให้มานั้นถูกต้อง
      <br></br>
      บริษัทฯ
      จะสามารถจัดเก็บข้อมูลส่วนตัวของท่านหากท่านส่งมอบข้อมูลให้เราด้วยความสมัครใจของท่านเท่านั้น
      หากท่านเลือกจะไม่ส่งข้อมูลจข้อมูลส่วนตัวของท่านให้แก่เราหรือเลือกที่จะเพิกถอนความยินยอมในการใช้ข้อมูลส่วนตัวของท่าน
      บริษัทฯอาจไม่สามารถให้บริการของบริษัทฯแก่ท่านได้
      ท่านอาจจะต้องเข้าถึงและปรับเปลี่ยนข้อมูลส่วนตัวของท่านที่ท่านได้ส่งมอบให้บริษัทฯได้ตลอดเวลา
      หากท่านได้ส่งมอบข้อมูลของบุคคลภายนอกให้แก่บริษัทฯ
      จะถือว่าท่านได้รับความยินยอมหรือได้รับอนุญาตจากบุคคลภายนอกผู้เกี่ยวข้องที่จะเปิดเผยและส่งมอบข้อมูลส่วนตัวนั้น
      ๆ แก่บริษัทฯ ในกรณีที่ท่านไม่ยินยอมให้บริษัทฯ ทำการเก็บและประมวลผลข้อมูลจำเป็นบางอย่างของท่าน
      บริษัทฯ
      อาจไม่สามารถให้การเข้าถึงเนื้อหาหรือใช้งานฟีเจอร์บางอย่างของผลิตภัณฑ์และ/หรือบริการแก่ท่านและ/หรือไม่สามารถดำเนินการตามคำขอหรือเข้าทำธุรกรรมกับท่านได้{' '}
      <br></br>
      3.1.2 ข้อมูลส่วนบุคคลที่บริษัทฯ ได้รับมาจากบุคคลภายนอก<br></br>
      บริษัทฯ อาจได้รับข้อมูลส่วนบุคคลของท่านมาจากบุคคลภายนอก เช่น<br></br>
      ผู้ควบคุมข้อมูลส่วนบุคคลร่วมที่เป็นพันธมิตรของบริษัท
      หรือผู้ควบคุมข้อมูลส่วนบุคคลอีกรายหนึ่งที่มีความสัมพันธ์หรือให้บริการอื่นแก่ท่าน<br></br>
      บริษัทอาจเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากบุคคลที่สาม ซึ่งเป็นผู้ให้บริการต่างๆ
      แก่บริษัทที่เกี่ยวเนื่องกับวัตถุประสงค์การประมวลผลข้อมูลส่วนบุคคลของท่าน
      โดยผู้ให้บริการนี้อยู่ในสถานะผู้ประมวลผลข้อมูลส่วนบุคคลซึ่งทำการในนามหรือตามคำสั่งบริษัท
      <br></br>
      บริษัทอาจเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากบุคคลที่สาม ซึ่งเป็นผู้ให้บริการต่างๆ
      แก่บริษัทที่เกี่ยวเนื่องกับวัตถุประสงค์การประมวลผลข้อมูลส่วนบุคคลของท่าน
      โดยผู้ให้บริการนี้อยู่ในสถานะผู้ควบคุมข้อมูลส่วนบุคคลอีกรายหนึ่ง เช่น ผู้ให้บริการขนส่ง
      ผู้ให้บริการชำระเงิน ผู้ให้บริการธุรกรรมอิเล็กทรอนิก<br></br>
      การเก็บข้อมูลจากผู้ให้บริการต่าง ๆ ของบริษัทฯ เช่น ผู้ให้บริการเว็บไซต์
      ผู้ให้บริการแอปพลิเคชัน ผู้ให้บริการพื้นที่พาณิชย์อิเล็กทรอนิกส์ (E- Commerce)
      ผู้ให้บริการศูนย์บริการข้อมูลลูกค้า (Call Center)
      ผู้ให้บริการประชาสัมพันธ์และแนะนำสินค้า/บริการ หรือผู้ให้บริการรวบรวมข้อมูล
      ซึ่งท่านอนุญาตให้ผู้ให้บริการนั้น ๆ เก็บรวบรวมและเปิดเผยข้อมูลของท่านได้<br></br>
      บางกรณีบริษัทฯ อาจเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากแหล่งข้อมูลสาธารณะ
      แหล่งข้อมูลเกี่ยวกับธุรกิจของท่าน หรือแหล่งข้อมูลทางการค้า
      ไม่ว่าท่านจะเป็นผู้เปิดเผยข้อมูลส่วนบุคคลด้วยตนเองหรือได้ให้ความยินยอมแก่ผู้ใดในการเปิดเผยข้อมูลส่วนบุคคลของท่านดังกล่าว
      <br></br>
      3.2. ในการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน ท่านจะได้รับการแจ้งถึงรายละเอียดต่าง ๆ
      ตามที่ระบุในนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ซึ่งรวมถึงวัตถุประสงค์และฐานทางกฎหมายในการเก็บรวบรวม
      ใช้ เปิดเผย และ/หรือ ประมวลผลข้อมูลส่วนบุคคล
      ที่ได้กำหนดให้การประมวลผลข้อมูลส่วนบุคคลใดต้องได้รับความยินยอมจากท่าน บริษัทฯ
      จะขอความยินยอมโดยชัดแจ้งจากท่าน<br></br>
      3.3. กรณีที่บริษัทฯ
      เก็บรวบรวมข้อมูลส่วนบุคคลของท่านไว้ก่อนวันที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลในส่วนที่เกี่ยวข้องกับการเก็บรวบรวม
      ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลมีผลใช้บังคับ บริษัทฯ
      จะเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลของท่านต่อไปตามวัตถุประสงค์เดิมที่บริษัทฯ
      ได้แจ้งไว้แก่ท่านในการเก็บรวบรวมข้อมูลส่วนบุคคล ซึ่งท่านมีสิทธิที่จะยกเลิกความยินยอมได้
      โดยติดต่อมายังบริษัทฯ
      ตามรายละเอียดการติดต่อที่ระบุไว้ในท้ายนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ทั้งนี้ บริษัทฯ
      ขอสงวนสิทธิในการพิจารณาคำขอยกเลิกความยินยอมของท่าน
      และดำเนินการตามฐานประมวลผลที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนดกำหนดไว้ในพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
      พ.ศ. 2562<br></br>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4. ข้อมูลส่วนบุคคลที่บริษัทฯ เก็บรวบรวม<br></br>
        บริษัทฯ จะทำการเก็บรวบรวม ใช้ เปิดเผย
        และ/หรือโอนไปยังต่างประเทศซึ่งข้อมูลส่วนบุคคลเท่าที่จำเป็นและเพื่อวัตถุประสงค์เกี่ยวกับการดำเนินธุรกิจของบริษัทฯ
        โดยบริษัทฯ
        จะเก็บและประมวลผลข้อมูลส่วนบุคคลตามความยินยอมของท่านหรือในกรณีที่กฎหมายอนุญาตเท่านั้น
        ทั้งนี้ ข้อมูลส่วนบุคคลที่บริษัทฯ เก็บรวบรวมจะขึ้นอยู่กับความสัมพันธ์ระหว่างท่านกับบริษัทฯ
        และประเภทของผลิตภัณฑ์และ/หรือบริการที่ท่านได้ใช้ ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะข้อมูลดังต่อไปนี้
        <br></br>
        <br></br>
        <table className={stylesOne.table}>
          <thead>
            <tr>
              <th>ประเภทข้อมูลส่วนบุคคล</th>
              <th>ข้อมูลส่วนบุคคลที่ถูกเก็บรวบรวม</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> ข้อมูลส่วนบุคคล </td>
              <td>• คำนำหน้าชื่อ ชื่อ-นามสกุล</td>
            </tr>

            <tr>
              <td></td>
              <td>• อายุ</td>
            </tr>

            <tr>
              <td></td>
              <td>• เพศ</td>
            </tr>

            <tr>
              <td></td>
              <td>• วันเดือนปีเกิด</td>
            </tr>

            <tr>
              <td></td>
              <td>• สัญชาติ</td>
            </tr>

            <tr>
              <td></td>
              <td>• หมายเลขบัตรประจำตัวประชาชน</td>
            </tr>

            <tr>
              <td></td>
              <td>• รูปถ่าย</td>
            </tr>

            <tr className={stylesOne.lastRow}>
              <td></td>
              <td>• ลายมือชื่อ </td>
            </tr>
            {/* ////////////////////////////////////////////////////////// */}
            <tr>
              <td>ข้อมูลสำหรับการติดต่อ</td>
              <td>• ที่อยู่ตามที่ปรากฏบนหน้าบัตรประจำตัวประชาชน</td>
            </tr>

            <tr>
              <td></td>
              <td>• หมายเลขโทรศัพท์ หมายเลขโทรศัพท์มือถือ</td>
            </tr>

            <tr>
              <td></td>
              <td>• ชื่อของตัวแทนหรือผู้มีอำนาจกระทำการแทน (กรณีมีตัวแทนหรือเป็นนิติบุคคล)</td>
            </tr>

            <tr className={stylesOne.lastRow}>
              <td></td>
              <td>• ชื่อบัญชีสื่อสังคมออนไลน์ เช่น ไลน์ไอดี (LINE ID)</td>
            </tr>

            {/* ////////////////////////////////////////////////////////// */}
            <tr>
              <td>ข้อมูลที่ใช้ในการระบุตัวตนและการยืนยันตัวตน</td>
              <td>• ภาพถ่ายบัตรประจำตัวประชาชน</td>
            </tr>

            <tr>
              <td></td>
              <td>• ภาพถ่ายหนังสือเดินทางหรือใบอนุญาตทำงาน (กรณีที่เป็นชาวต่างชาติ)</td>
            </tr>

            <tr>
              <td></td>
              <td>• หมายเลขประจำตัวผู้เสียภาษี</td>
            </tr>

            <tr className={stylesOne.lastRow}>
              <td></td>
              <td>• ลายมือชื่อ</td>
            </tr>

            {/* ////////////////////////////////////////////////////////// */}
            <tr>
              <td>ข้อมูลเกี่ยวกับธุรกรรมการซื้อขาย</td>
              <td>• ข้อมูลส่วนบุคคลที่เกี่ยวข้องกับการทำคำสั่งซื้อขาย</td>
            </tr>

            <tr>
              <td></td>
              <td>• การชำระราคา</td>
            </tr>

            <tr>
              <td></td>
              <td>• การนัดหมายสถานที่ซื้อขาย</td>
            </tr>

            <tr className={stylesOne.lastRow}>
              <td></td>
              <td>• ชื่อและหมายเลขบัญชีธนาคาร</td>
            </tr>

            {/* ////////////////////////////////////////////////////////// */}
            <tr>
              <td>ข้อมูลทางเทคนิค</td>
              <td>• หมายเลขเฉพาะของแอพพลิเคชั่น (Unique Application Number)</td>
            </tr>

            <tr>
              <td></td>
              <td>• ข้อมูลเครื่องโทรศัพท์เคลื่อนที่</td>
            </tr>

            <tr>
              <td></td>
              <td>• หมายเลขประจำเครื่อง หรือ MEI/MEID และ ICCID</td>
            </tr>

            <tr>
              <td></td>
              <td>
                • ข้อมูลอุปกรณ์คอมพิวเตอร์ เช่น รุ่นฮาร์ดแวร์ ระบบปฏิบัติการและรุ่นของระบบปฏิบัติการ
              </td>
            </tr>

            <tr>
              <td></td>
              <td>• MAC address</td>
            </tr>

            <tr>
              <td></td>
              <td>• เลขหมายไอพี</td>
            </tr>

            <tr>
              <td></td>
              <td>• ข้อมูลเบราเซอร์</td>
            </tr>

            <tr>
              <td></td>
              <td>• ข้อมูล iCoud</td>
            </tr>

            <tr>
              <td></td>
              <td>• ข้อมูล MDM</td>
            </tr>

            <tr>
              <td></td>
              <td>• เลขโมเดล</td>
            </tr>

            <tr>
              <td></td>
              <td>• ข้อมูลการใช้งานเว็บไซต์และแอปพลิเคชันที่สามารถเชื่อมโยงระบุตัวท่าน</td>
            </tr>

            <tr>
              <td></td>
              <td>
                •
                ข้อมูลทางเทคนิคที่สร้างขึ้นและสามารถเชื่อมโยงระบุตัวท่านเพื่อการดำเนินการที่เกี่ยวข้องกับการใช้งานเว็บไซต์และแอปพลิเคชั่น
              </td>
            </tr>

            <tr className={stylesOne.lastRow}>
              <td></td>
              <td>
                •
                ข้อมูลที่ท่านได้ให้ไว้แก่ผู้ให้บริการแพลตฟอร์มออนไลน์อื่นโดยสมัครใจตามนโยบายของผู้ให้บริการดังกล่าวและอนุญาตให้บริษัทฯ
                เข้าถึงข้อมูลดังกล่าวเมื่อท่านเข้าใช้งานผลิตภัณฑ์และ/หรือบริการด้วยวิธีการลงชื่อเข้าระบบครั้งเดียวด้วย
                (SSO) เช่น หมายเลขบัญชีผู้ใช้งาน (Apple ID)
              </td>
            </tr>

            {/* ////////////////////////////////////////////////////////// */}
            <tr className={stylesOne.lastRow}>
              <td>ข้อมูลภาพหรือวีดิโอ</td>
              <td>
                •
                ในกรณีที่ท่านเป็นผู้นำเข้าสู่ระบบของบริษัทเพื่อประกอบการซื้อขายหรือเพื่อการแสดงความเห็นเกี่ยวกับการซื้อขาย
              </td>
            </tr>

            {/* ////////////////////////////////////////////////////////// */}
            <tr className={stylesOne.lastRow}>
              <td>
                <p>ข้อมูลคอมพิวเตอร์</p>
              </td>
              <td>
                • โดยบริษัทฯ หรือผู้ให้บริการที่ได้รับอนุญาตจากบริษัทฯ อาจมีการใช้คุกกี้ เว็บบีคอนส์
                หรือ
                เทคโนโลยีอื่นใดในการเก็บข้อมูลเพื่อช่วยเหลือท่านให้สามารถใช้บริการและเข้าถึงการบริการได้รวดเร็วและปลอดภัยมากยิ่งขึ้น
                ซึ่งข้อมูลดังกล่าวนี้ รวมถึง IP address เว็บไซต์ที่นำท่านมาสู่เว็บไซต์ของบริษัท
                ระยะเวลาในการเยี่ยมชมเว็บไซต์ ข้อมูลการค้นหา ช่วงเวลาที่เยี่ยมชม
                หรือข้อมูลทางสถิติอื่น ๆ
              </td>
            </tr>

            {/* ////////////////////////////////////////////////////////// */}
            <tr>
              <td>ข้อมูลอื่น ๆ</td>
              <td>• เสียงสนทนาในการติดต่อสื่อสารกับบริษัท</td>
            </tr>

            <tr className={stylesOne.lastRow}>
              <td></td>
              <td>• พฤติกรรมหรือแนวโน้มในการซื้อขายสินค้าและ/หรือบริการ</td>
            </tr>
          </tbody>
        </table>
      </p>
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5. วัตถุประสงค์ในการเก็บรวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคล
      <br></br>
      บริษัททำการเก็บรวบรวมใช้ เปิดเผยข้อมูลผู้ใช้งานและผู้ขาย เพื่อวัตถุประสงค์ต่อไปนี้<br></br>
    </p>
    <table className={stylesTwo.table}>
      <thead>
        <tr>
          <th>ลำดับ</th>
          <th>วัตถุประสงค์</th>
          <th>ฐานประมวลผลตามกฎหมาย</th>
        </tr>
      </thead>
      <tbody>
        <tr className={stylesOne.lastRow}>
          <td>1.</td>
          <td>เพื่อประโยชน์ในการดำเนินการตามคำขอของท่านก่อนการทำสัญญาหรือข้อตกลงใช้งานกับบริษัท</td>
          <td>
            <b>ฐานความยินยอม</b> การประมวลผลข้อมูลส่วนบุคคลของท่านในขั้นตอนการตกลงเข้าใช้งานเว็บไซต์
            ในฐานะผู้ขาย เช่น การตรวจสอบยืนยันตัวตน การลงทะเบียนเพื่อประเมิณราคา
            การลงทะเบียนเพื่อนัดหมายวันเวลาและสถานที่ซื้อขายสินค้า
            การลงทะเบียนการบันทึกหรือเก็บรวบรวมข้อมูลเข้าสู่ระบบการให้บริการเว็บไซต์
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>2.</td>
          <td>
            เพื่อวัตถุประสงค์ในการวิเคราะห์ข้อมูลและสำรวจพฤติกรรมของลูกค้า
            หรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน
          </td>
          <td>
            <b>ฐานความยินยอม</b> การที่บริษัทฯ เป็นฝ่ายเข้าขอสัมภาษณ์ สำรวจ
            และสังเกตพฤติกรรมของลูกค้า เพื่อขอเก็บรวบรวมข้อมูลส่วนบุคคล
            หรือการซื้อข้อมูลส่วนบุคคลของลูกค้ามาจากบุคคลภายนอก
            เพื่อนำมาวิเคราะห์ข้อมูลและสำรวจพฤติกรรมของลูกค้า หรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน
            บริษัทฯ จะ ดำเนินการโดยอาศัยความยินยอมที่ได้รับจากลูกค้า หรือบุคคล
            อื่นใดที่มีลักษณะคล้ายคลึงกันก่อนหรือในขณะที่เก็บข้อมูล
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>3.</td>
          <td>เพื่อวัตถุประสงค์ในการทำสัญญาระหว่างท่านและบริษัท</td>
          <td>
            <b>ฐานสัญญา</b> การประมวลผลข้อมูลส่วนบุคคลของลูกค้า หรือ
            บุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน เป็นการจำเป็นเพื่อการเข้าทำสัญญา และกระบวนการอื่น ๆ
            ที่เกี่ยวข้องกับการเข้าทำสัญญา เช่น การตรวจสอบหลักฐานประกอบการทำสัญญา
            และการวางหลักประกัน เป็นต้น<br></br>
            <br></br>• บริษัทฯ จะดำเนินการเก็บรวบรวม ใช้
            เปิดเผยและ/หรือโอนไปยังต่างประเทศซึ่งข้อมูลส่วนบุคคลของท่านตามวัตถุประสงค์และข้อตกลงที่ท่านได้ทำไว้กับบริษัทฯ
            ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะ<br></br>•
            บริษัทประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อการดำเนินการต่างๆที่
            เกี่ยวข้องกับการซื้อสินค้าของท่าน ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะ การทำคำสั่งซื้อ
            การส่งคำสั่งซื้อในแพลตฟอร์มของบริษัท การติดต่อสื่อสารเพื่อตอบคำถาม แก้ไข
            การดำเนินการเกี่ยวกับการซื้อสินค้าของท่าน การชำระราคา
            ซึ่งรวมถึงการประมวลผลหรือเปิดเผยข้อมูลของท่านแก่ผู้ให้บริการที่เกี่ยวข้องกับการชำระเงิน
            เช่น สถาบันการเงิน <br></br>
            <br></br>
            <b>ฐานประโยชน์อันชอบด้วยกฎหมาย</b>{' '}
            ในกรณีที่ลูกค้าหรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกันเป็นนิติบุคคล
            การประมวลผลข้อมูลส่วนบุคคลของผู้ที่เกี่ยวข้องกับลูกค้าหรือของบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน
            เป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายในการดำเนินธุรกิจของบริษัทฯ เช่น
            การบริหารจัดการสัญญา การตรวจสอบยืนยันตัวตนของลูกค้า และการพิจารณาคุณสมบัติลูกค้า เป็นต้น
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>4.</td>
          <td>
            เพื่อวัตถุประสงค์ในการบริหารจัดการคำสั่งซื้อจากลูกค้าหรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน
            ทั้งการดำเนินการ ณ สำนักงานสาขาของบริษัทฯ และผ่านระบบ E-Commerc
          </td>
          <td>
            <b>ฐานสัญญา</b> การประมวลผลข้อมูลส่วนบุคคลของลูกค้า
            หรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน
            เป็นความจำเป็นเพื่อปฏิบัติหน้าที่ตามสัญญาซื้อขายและบริการ
            ซึ่งลูกค้าหรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกันเป็นคู่สัญญา เช่น
            การซื้อขายผ่านช่องทางใด ๆ ไม่ว่าจะเป็นช่องทางของบริษัทฯ โดยตรง หรือช่องทางของบุคคลที่สาม
            เช่น การซื้อขาย ณ จุดขาย ผ่านเว็บไซต์ หรือช่องทางอื่น ๆ เป็นต้น <br></br>
            <br></br>
            <b>ฐานประโยชน์อันชอบด้วยกฎหมาย</b> ในกรณีที่ลูกค้า หรือบุคคล
            อื่นในลักษณะคล้ายคลึงกันเป็นนิติบุคคล
            การประมวลผลข้อมูลส่วนบุคคลของผู้ที่เกี่ยวข้องกับลูกค้าหรือของบุคคลอื่นในลักษณะคล้ายคลึงกัน
            เป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายในการดำเนินธุรกิจของบริษัทฯ เช่น
            การบริหารจัดการหมายเลขการนัดหมายจากลูกค้า และการตรวจสอบยืนยันตัวตนของลูกค้า เป็นต้น
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>5.</td>
          <td>
            เพื่อวัตถุประสงค์ในการดำเนินการแก้ไขเปลี่ยนแปลงรายละเอียดเกี่ยวกับลูกค้าใน
            ระบบของบริษัทฯ
          </td>
          <td>
            <b>ฐานประโยชน์อันชอบด้วยกฎหมาย</b>
            การประมวลผลข้อมูลส่วนบุคคลของลูกค้า
            ผู้ที่เกี่ยวข้องกับลูกค้าหรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน
            เป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายในการอำนวยความสะดวกแก่ลูกค้า
            ผู้ที่เกี่ยวข้องกับลูกค้า หรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกันในการแก้ไข
            เปลี่ยนแปลงรายละเอียดเกี่ยวกับลูกค้าหรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน
            ในระบบของบริษัทฯ ให้มีความถูกต้อง เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>6.</td>
          <td>
            เพื่อวัตถุประสงค์ในการรับเรื่องร้องเรียนจากลูกค้า ผู้ที่เกี่ยวข้องกับลูกค้า
            หรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน
          </td>
          <td>
            <b>ฐานประโยชน์อันชอบด้วยกฎหมาย</b>
            การประมวลผลข้อมูลส่วนบุคคลของลูกค้า หรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน
            เป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายในการอำนวยความสะดวกแก่ลูกค้า
            ผู้ที่เกี่ยวข้องกับลูกค้า หรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน
            ในการร้องเรียนหรือส่งข้อเสนอแนะจาก ลูกค้า หรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน
            เพื่อเป็นการพัฒนาคุณภาพการให้บริการของบริษัทฯ
            รวมทั้งอาจมีการส่งต่อแก่บุคคลภายนอกเพื่อดำเนินการแก้ไขข้อร้องเรียน
            และ/หรือการปฏิบัติตามคำขอของท่าน
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>7.</td>
          <td>
            เพื่อวัตถุประสงค์ในการประชาสัมพันธ์ เสนอสินค้าและบริการ
            รวมถึงเพื่อกิจกรรมทางการตลาดของบริษัทฯ{' '}
          </td>
          <td>
            <b>ฐานความยินยอม</b>
            การประชาสัมพันธ์ การโฆษณา การส่งเสริมการขาย และการลูกค้าสัมพันธ์ บริษัทฯ
            อาจดำเนินกิจกรรมทางการตลาดใด ๆ เพื่อการประชาสัมพันธ์มายังท่านหรือเป็นสาธารณะ เช่น
            การส่งข้อความเกี่ยวกับการสื่อสารทางการตลาด หรือการนำเสนอสินค้าและบริการให้แก่ลูกค้า
            การขอถ่ายภาพนิ่งหรือภาพเคลื่อนไหวของลูกค้า
            เพื่อนำไปประมวลภาพและประชาสัมพันธ์กิจกรรมการตลาดตามช่องทางสื่อต่าง ๆ บริษัทฯ
            จะดำเนินการโดยขอความยินยอม จากท่านก่อนหรือขณะที่ดำเนินกิจกรรม
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>8.</td>
          <td>
            เพื่อวัตถุประสงค์ในการวิเคราะห์การใช้งาน เว็บไซต์ แอปพลิเคชัน หรือช่องทางอื่น ๆ ของท่าน
            เพื่อพัฒนาคุณภาพการให้บริการของ บริษัทฯ หรือเพื่อวัตถุประสงค์ทางการตลาด
          </td>
          <td>
            <b>ฐานประโยชน์อันชอบด้วยกฎหมาย</b> การประมวลผลข้อมูลส่วนบุคคลของท่านจากการใช้งานเว็บไซต์
            หรือช่องทางอื่น ๆ เป็นการจำเป็นเพื่อประโยชน์ชอบด้วยกฎหมายของบริษัทฯ
            เพื่อดำเนินธุรกิจและการพัฒนาคุณภาพการให้บริการของบริษัทฯ เช่น การปรับปรุงเว็บไซต์
            หรือช่องทางอื่น ๆ การพัฒนาบริการ ตลอดจนการแก้ไขข้อบกพร่องและปัญหาต่าง ๆ ที่เกี่ยวข้องกับ
            บริการ<br></br>
            <br></br>
            <b>ฐานความยินยอม</b> ในกรณีที่บริษัทฯ เก็บรวบรวมและ
            ประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อนำมาวิเคราะห์พฤติกรรมและทำโฆษณาแบบเจาะจงตามพฤติกรรมของท่าน
            หรือทำการตลาดแบบตรง หรือในกรณีที่กฎหมายว่าด้วยการ
            คุ้มครองข้อมูลส่วนบุคคลกำหนดให้ต้องได้รับความยินยอมจากท่าน บริษัทฯ
            จะดำเนินการโดยอาศัยความยินยอมที่ได้รับจากท่านก่อนหรือขณะที่ดำเนินการ
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>9.</td>
          <td>
            เพื่อวัตถุประสงค์ในการติดต่อสื่อสารกับลูกค้า หรือบุคคลอื่นใดที่มีลักษณะคล้ายคลึงกัน
          </td>
          <td>
            <b>ฐานประโยชน์อันชอบด้วยกฎหมาย</b>{' '}
            การประมวลผลข้อมูลส่วนบุคคลเป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมาย
            ในการติดต่อสื่อสารกับท่านเกี่ยวกับการให้บริการต่าง ๆ ของบริษัทฯ เช่น
            การดำเนินการตามคำขอใช้บริการ การตอบข้อซักถาม หรือข้อเสนอแนะของท่าน เป็นต้น
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>10.</td>
          <td>
            เพื่อวัตถุประสงค์ในการปฏิบัติตามกฎหมายที่ เกี่ยวข้องกับธุรกิจของบริษัทฯ
            และคำสั่งโดยชอบด้วยกฎหมายของหน่วยงานของรัฐและเจ้าหน้าที่ที่เกี่ยวข้อง
          </td>
          <td>
            <b>ฐานกฎหมาย</b> เพื่อการปฏิบัติตามกฎหมายซึ่งบังคับใช้กับบริษัทฯ เช่น
            กฎหมายว่าด้วยภาษีอากร กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล
            และคำสั่งโดยชอบด้วยกฎหมายของหน่วยงานของรัฐและเจ้าหน้าที่ที่เกี่ยวข้อง เช่น
            สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล เป็นต้น
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>11.</td>
          <td>
            เพื่อวัตถุประสงค์ในการเรียกร้องสิทธิตาม กฎหมาย
            การปฏิบัติตามหรือการใช้สิทธิเรียกร้องตามกฎหมาย
            หรือการยกขึ้นต่อสู้ซึ่งสิทธิเรียกร้องของบริษัทฯ
          </td>
          <td>
            <b>ฐานประโยชน์อันชอบด้วยกฎหมาย</b>{' '}
            บริษัทประมวลผลข้อมูลส่วนบุคคลของผู้ใช้งานโดยได้รับความยินยอมจากเจ้าของข้อมูลด้วยวิธีการตามที่กฎหมายกำหนด
            เว้นแต่กรณีที่กฎหมายกำหนดเงื่อนไขหรือเหตุผลอื่นที่ให้ทำได้โดยไม่ต้องขอความยินยอมจากเจ้าของข้อมูลส่วนบุคคล
            เช่น การปฎิบัติตามสัญญา ปฎิบัติตามกฎหมาย
            เพื่อประโยชน์โดยชอบด้วยกฎหมายของผู้ควบคุมข้อมูลหรือความปลอดภัยของเจ้าของข้อมูลท่านอื่น
            เพื่อประโยชน์แก่การสอบสวนของพนักงานสอบสวน หรือการพิจารณาพิพากษาคดีของศาล
            การใช้สิทธิเรียกร้องตามกฎหมาย หรือการยกขึ้นต่อสู้ซึ่งสิทธิเรียกร้องของบริษัทฯ
            ในขั้นตอนต่าง ๆ ตามกฎหมาย เป็นต้น
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>12.</td>
          <td>
            เพื่อการดำเนินการใด ๆ ที่จำเป็นและเป็นประโยชน์ต่อท่าน หรือเกี่ยวข้องโดยตรงกับ
            วัตถุประสงค์ที่กำหนดใด ๆ ข้างต้น
          </td>
          <td>
            <b>ฐานประโยชน์อันชอบด้วยกฎหมาย</b>{' '}
            การประมวลผลข้อมูลส่วนบุคคลเป็นการจำเป็นเพื่อประโยชน์อันชอบด้วยกฎหมายของบริษัทฯ
            ในการดำเนินการใด ๆ ที่จำเป็นของบริษัทฯ และ/หรือเป็นประโยชน์ต่อท่าน
            หรือเกี่ยวข้องโดยตรงกับวัตถุประสงค์ที่กำหนดข้างต้น
            หากเป็นกรณีที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนดให้การประมวลผลข้อมูลส่วนบุคคลใด
            ต้องได้รับความยินยอมจากท่าน บริษัทฯ
            จะขอความยินยอมโดยชัดแจ้งจากท่านก่อนหรือระหว่างการดำเนินการ
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>13.</td>
          <td>
            เพื่อบริหารจัดการระบบเทคโนโลยีสารสนเทศของบริษัทฯ อำนวยความสะดวกด้านลูกค้าสัมพันธ์
            รักษาความมั่นคงปลอดภัย วิเคราะห์และตรวจสอบการละเมิด
          </td>
          <td>
            <b>ฐานประโยชน์อันชอบด้วยกฎหมาย</b> บริหารจัดการความสัมพันธ์ระหว่างท่านและบริษัทฯ (เช่น
            การดูแลลูกค้า การสำรวจความพึงพอใจ จัดการข้อร้องเรียนและข้อพิพาท
            การบันทึกเสียงการร้องเรียนผ่านระบบ Call Center) และการดำเนินการแก้ไขข้อพิพาท
            การเริ่มดำเนินการ การใช้สิทธิ หรือการโต้แย้งข้อเรียกร้องทางกฎหมาย
            ตลอดจนสิทธิและทรัพย์สิน ของบริษัทฯ พนักงานของบริษัทฯ และผู้ใช้งานและลูกค้าของบริษัทฯ
            (เช่น การบันทึกภาพ CCTV และ/หรือ การบันทึกผู้ติดต่อเข้า-ออกของบริษัทฯ)
            การจัดการความเสี่ยงด้านเทคโนโลยีสารสนเทศ
            การรักษาความมั่นคงปลอดภัยในการป้องกันและรับมือภัยคุกคามทางไซเบอร์
            การเฝ้าติดตามข้อมูลการใช้เครือข่าย
            การวิเคราะห์และตรวจสอบเกี่ยวกับความปลอดภัยของข้อมูลการกระทำละเมิดเกี่ยวกับเงื่อนไขการใช้ผลิตภัณฑ์และ/หรือบริการของบริษัทฯ
            การฉ้อโกง การทุจริต การประพฤติโดยมิชอบ การก่ออาชญากรรม หรือกิจกรรมใด ๆ ที่ผิดกฎหมาย
          </td>
        </tr>
        <tr className={stylesOne.lastRow}>
          <td>14.</td>
          <td>เพื่อวัตถุประสงค์อื่น ๆ ที่บริษัทฯ จะแจ้งให้ ท่านทราบ</td>
          <td>
            บริษัทฯ จะแจ้งให้ท่านทราบถึงวัตถุประสงค์อื่นใดอันเป็นเหตุให้บริษัทฯ
            ต้องประมวลผลข้อมูลส่วนบุคคลของท่าน
            นอกเหนือไปจากวัตถุประสงค์ตามที่ระบุไว้ข้างต้นหรือเมื่อบริษัทฯ
            มีการเปลี่ยนแปลงวัตถุประสงค์เดิมที่กำหนดไว้ <br></br>
            <br></br>
            ทั้งนี้
            หากเป็นกรณีที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนดให้การประมวลผลข้อมูลส่วนบุคคลใดต้องได้รับความยินยอมจากท่าน
            บริษัทฯ จะขอความยินยอมโดยชัดแจ้งจากท่านก่อนหรือระหว่างการดำเนินการ
          </td>
        </tr>
      </tbody>
    </table>
    <br></br>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6. การเปิดเผยข้อมูลส่วนบุคคลของท่าน</p>
    <p>
      โดยทั่วไป บริษัทฯ จะไม่เปิดเผยและส่งต่อข้อมูลส่วนบุคคลของท่านไปยังบุคคลหรือหน่วยงานภายนอก
      เว้นแต่บริษัทฯ จะได้รับความยินยอมจากท่านหรือเพื่อเป็นการปฏิบัติหน้าที่ตามกฎหมายที่ใช้บังคับ
      อย่างไรก็ตาม ในการดำเนินธุรกิจของบริษัทฯ และภายใต้วัตถุประสงค์ตามที่ระบุในนโยบายนี้ บริษัทฯ
      อาจจำเป็นต้องเปิดเผยหรือแบ่งปันข้อมูลส่วนตัวของท่านบางส่วนเฉพาะเท่าที่จำเป็นแก่บุคคลภายนอก
      (ซึ่งอาจมีที่ตั้งหรือให้บริการอยู่ในประเทศไทยหรือต่างประเทศ) ดังต่อไปนี้ 6.1. บริษัทเปิดเผย
      ส่ง โอน ข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์เพื่อการประมวลผลข้อมูลส่วนบุคคลของท่าน บริษัท
      ร้านร่าเริง จำกัด หมายถึง ผู้บริหาร กรรมการ พนักงาน ลูกจ้าง
      และ/หรือบุคลากรภายในของบริษัทดังกล่าวเท่าที่เกี่ยวข้องและตามความจำเป็น
    </p>
    <p>
      6.1 บริษัทเปิดเผย ส่ง โอน
      ข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์เพื่อการประมวลผลข้อมูลส่วนบุคคลของท่าน บริษัท ร้านร่าเริง
      จำกัด หมายถึง ผู้บริหาร กรรมการ พนักงาน ลูกจ้าง
      และ/หรือบุคลากรภายในของบริษัทดังกล่าวเท่าที่เกี่ยวข้องและตามความจำเป็น
    </p>
    <p>
      6.2 บริษัทเปิดเผย ส่ง โอน ข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์คู่ค้าทางธุรกิจ ผู้ให้บริการ
      และผู้ประมวลผลข้อมูลส่วนบุคคลที่บริษัทฯ
      มอบหมายหรือว่าจ้างให้ทำหน้าที่บริหารจัดการประมวลผลข้อมูลส่วนบุคคลให้แก่บริษัทฯ
      ในการให้บริการต่าง ๆ เช่น การให้บริการด้านเทคโนโลยีสารสนเทศ บริการเก็บบันทึกข้อมูล
      บริการชำระเงิน บริการวิเคราะห์ข้อมูล บริการทำการตลาด ผู้ให้บริการขนส่ง
      หรือบริการอื่นใดที่อาจเป็นประโยชน์ต่อท่าน หรือเกี่ยวข้องกับการดำเนินธุรกิจของบริษัทฯ
    </p>
    <p>
      6.3 บริษัทเปิดเผย ส่ง โอน
      ข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์บุคคลที่เกี่ยวข้องเป็นที่ปรึกษาของบริษัทฯ
      ซึ่งอาจเป็นผู้ประมวลผลข้อมูลส่วนบุคคลหรือผู้ควบคุมข้อมูลส่วนบุคคลอื่น
      เพื่อประโยชน์ในการดำเนินการหรือปฎิบัติการหรือเพื่อดำเนินการให้เป็นไปตามคำขอก่อนเข้าทำสัญญาหรือตกลงใช้งาน
      และเพื่อดำเนินการให้บริการตามข้อตกลงใช้งานทั้งในส่วนของผู้ใช้งานที่เป็นผู้ซื้อและผู้ขาย
      โดยไม่ต้องอาศัยความยินยอมจากท่านตามที่กฎหมายกำหนดเช่น ที่ปรึกษากฎหมาย ผู้ตรวจสอบบัญชี
      หรือผู้เชี่ยวชาญอื่นใด ทั้งภายในและภายนอกของบริษัทฯ ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะการเปิดเผย ส่ง
      โอน ข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์และแอปพลิเคชั่นให้กับ
      ผู้ให้บริการทางด้านเทคโนโลยีหรือระบบสารสนเทศต่างๆ เช่น
      ผู้ให้บริการเก็บข้อมูลบนคอมพิวเตอร์เซิร์ฟเวอร์หรือคลาวด์
      การส่งข้อมูลของผู้ใช้งานให้กับผู้ให้บริการขนส่งเพื่อจัดส่งสินค้าตามคำสั่งซื้อ เป็นต้น
    </p>
    <p>
      6.4 บริษัทเปิดเผย ส่ง โอน
      ข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์หน่วยงานของรัฐที่มีหน้าที่กำกับดูแลตามกฎหมาย
      หรือที่ร้องขอให้เปิดเผยข้อมูลส่วนบุคคลโดยอาศัยอำนาจตามกฎหมาย
      หรือที่เกี่ยวข้องกับกระบวนการทางกฎหมาย หรือที่ได้รับอนุญาตตามกฎหมายที่เกี่ยวข้อง เช่น
      กรมสรรพากร กระทรวงพาณิชย์ สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล เป็นต้น
    </p>
    <p>
      6.5 บริษัทเปิดเผย ส่ง โอน
      ข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์บุคคลหรือหน่วยงานอื่นใดที่ท่านให้ความยินยอมให้เปิดเผยข้อมูลส่วนบุคคลของท่านต่อบุคคลหรือหน่วยงานนั้น
      ๆ เช่น การเปิดเผยการประมวลภาพกิจกรรมตามช่องทางสื่อต่าง ๆ ของบริษัทฯ ให้แก่ประชาชนทั่วไป
    </p>
    <p>
      6.6 บริษัทเปิดเผย ส่ง โอน
      ข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์การเปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลอื่น
      จะดำเนินการภายใต้วัตถุประสงค์ที่กำหนดหรือวัตถุประสงค์อื่นที่กฎหมายกำหนดให้กระทำได้เท่านั้น
      ในกรณีที่กฎหมายกำหนดว่าต้องได้รับความยินยอมจากท่าน บริษัทฯ
      จะขอความยินยอมจากท่านก่อนหรือระหว่างการดำเนินการ
    </p>
    <p>
      6.7 บริษัทเปิดเผย ส่ง โอน
      ข้อมูลส่วนบุคคลของผู้ใช้งานเว็บไซต์ในการเปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลอื่น บริษัทฯ
      จะจัดให้มีมาตรการที่เหมาะสมเพื่อคุ้มครองข้อมูลส่วนบุคคลที่ได้เปิดเผย
      และเพื่อปฏิบัติตามมาตรฐานและหน้าที่การคุ้มครองข้อมูลส่วนบุคคลตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนด
      ทั้งนี้ ในกรณีที่บริษัทฯ ส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปต่างประเทศ บริษัทฯ
      จะดำเนินการเพื่อทำให้แน่ใจว่าประเทศปลายทาง องค์การระหว่างประเทศ
      หรือผู้รับข้อมูลในต่างประเทศนั้นมีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลที่เพียงพอหรือเพื่อทำให้แน่ใจว่าการส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปต่างประเทศเป็นไปตามหลักเกณฑ์ที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนด
      โดยบริษัทฯ
      จะขอความยินยอมของท่านสำหรับการส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศดังกล่าว
    </p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7. การส่งหรือโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ</p>
    <p>
      บริษัทฯ
      อาจจะส่งหรือโอนข้อมูลส่วนบุคคลไปจัดเก็บและ/หรือประมวลผลตามที่ระบุในนโยบายความเป็นส่วนตัวฉบับนี้นอกประเทศไทย
      เช่น การส่งหรือโอนข้อมูลส่วนบุคคลเพื่อจัดเก็บไว้บน Server หรือ Cloud ในต่างประเทศ โดยบริษัทฯ
      จะทำให้แน่ใจว่าข้อมูลของท่านจะถูกส่งไปยังประเทศปลายทางหรือหน่วยงานปลายทางมีมาตรฐานและนโยบายในการคุ้มครองความเป็นส่วนตัวในระดับที่เพียงพอและเป็นไปตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลที่ใช้บังคับ
    </p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8. ข้อมูลส่วนบุคคลที่มีความอ่อนไหว</p>
    <p>
      ในการเสนอหรือส่งมอบผลิตภัณฑ์และ/หรือบริการแก่ท่าน บริษัทฯ อาจจำเป็นต้องเก็บรวบรวม ใช้
      เปิดเผยและ/หรือโอนไปยังต่างประเทศซึ่งข้อมูลส่วนบุคคลที่มีความอ่อนไหว
      ซึ่งรวมถึงข้อมูลส่วนบุคคลเกี่ยวกับความเชื่อทางศาสนา เชื้อชาติ ข้อมูลชีวภาพ ข้อมูลความพิการ
      ข้อมูลสุขภาพ ประวัติอาชญากรรม แล้วแต่กรณี ทั้งนี้ บริษัทฯ จะทำการเก็บรวบรวม ใช้
      เปิดเผยและ/หรือโอนไปยังต่างประเทศซึ่งข้อมูลส่วนบุคคลที่มีความอ่อนไหวต่อเมื่อบริษัทฯ
      ได้รับความยินยอมจากท่านและ/หรือเมื่อมีความจำเป็นในการปฏิบัติตามกฎหมายที่มีผลบังคับใช้เท่านั้น
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9. ข้อมูลส่วนบุคคลของผู้เยาว์ ผู้เสมือนไร้ความสามารถ
      และผู้ไร้ความสามารถ
    </p>
    <p>
      9.1 บริษัทฯ ไม่มีเจตนาที่จะเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลของบุคคลที่มีอายุต่ำกว่า 20 ปี
      โดยไม่ได้รับความยินยอมจากผู้ปกครองตามที่กฎหมายกำหนด
      และไม่มีเจตนาจะเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลของผู้เสมือนไร้ความสามารถและผู้ไร้ความสามารถ
      โดยไม่ได้รับความยินยอมจากผู้พิทักษ์หรือผู้อนุบาลตามกฎหมาย
      โดยท่านรับรองและรับประกันว่าท่านมีสิทธิ์และความสามารถทางกฎหมายในการใช้ผลิตภัณฑ์และ/หรือบริการของบริษัทฯ
      การที่บุคคลที่มีอายุต่ำกว่า 20 ปี ผู้เสมือนไร้ความสามารถ
      หรือผู้ไร้ความสามารถเข้าถึงหรือเริ่มต้นใช้ผลิตภัณฑ์และ/หรือบริการจะถือว่าบุคคลดังกล่าวได้รับความยินยอมจากผู้ปกครอง
      ผู้พิทักษ์ หรือผู้อนุบาลตามกฎหมายแล้ว
    </p>
    <p>
      9.2 ทั้งนี้ ในกรณีที่บริษัทฯ ทราบว่าบริษัทฯ
      เก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลของบุคคลที่มีอายุต่ำกว่า 20 ปี บุคคลเสมือนไร้ความสามารถ
      หรือบุคคลไร้ความสามารถโดยไม่มีความยินยอมของผู้ปกครอง ผู้พิทักษ์หรือผู้อนุบาลตามที่กฎหมายกำหนด
      แล้วแต่กรณี โดยไม่ได้ตั้งใจ บริษัทฯ
      จะลบข้อมูลส่วนบุคคลนั้นทันทีและ/หรือเก็บรวบรวมและประมวลผลข้อมูลของบุคคลเหล่านั้นตามความยินยอมหรือตามที่กฎหมายอนุญาตเท่านั้น{' '}
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10. การเก็บรักษาและระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคลของท่าน
    </p>
    <p>
      บริษัทฯ จะเก็บรักษาข้อมูลส่วนบุคคลของท่านตามระยะเวลาที่จำเป็น
      ตามวัตถุประสงค์ที่กำหนดในการประมวลผลข้อมูลส่วนบุคคลนั้น
      โดยระยะเวลาก็บรักษาข้อมูลส่วนบุคคลจะเปลี่ยนแปลงไปโดยขึ้นอยู่กับวัตถุประสงค์ที่กำหนดในการประมวลผลข้อมูลส่วนบุคคลนั้น
      ๆ
    </p>
    <p>
      นอกจากนี้ บริษัทฯ จะเก็บรักษาข้อมูลส่วนบุคคลเป็นระยะเวลาตามที่กฎหมายที่เกี่ยวข้องกำหนด (ถ้ามี)
      โดยคำนึงถึงอายุความตามกฎหมายสำหรับการดำเนินคดีที่อาจเกิดขึ้นจากหรือที่เกี่ยวข้องกับเอกสารหรือข้อมูลส่วนบุคคลที่บริษัทฯ
      เก็บรวบรวมไว้ในแต่ละรายการ และคำนึงถึงแนวปฏิบัติของบริษัทฯ
      และของภาคธุรกิจที่เกี่ยวข้องสำหรับข้อมูลส่วนบุคคลแต่ละประเภทเป็นสำคัญ
    </p>
    <p>
      ในเบื้องต้นบริษัทฯ จะเก็บรักษาข้อมูลส่วนบุคคลของท่านเป็นระยะเวลาไม่เกิน 2 ปี
      นับแต่วันที่นิติสัมพันธ์ระหว่างท่านกับบริษัทฯ สิ้นสุดลง อย่างไรก็ดี บริษัทฯ
      อาจเก็บรักษาข้อมูลส่วนบุคคลของท่านเป็นระยะเวลาเกินกว่าระยะเวลาดังกล่าว
      หากกฎหมายอนุญาตหรือการเก็บรักษาข้อมูลส่วนบุคคลดังกล่าวจำเป็นต่อการก่อตั้งสิทธิเรียกร้องทางกฎหมายของบริษัทฯ
    </p>
    <p>
      หลังจากครบกำหนดระยะเวลาดังกล่าวข้างต้น บริษัทฯ จะลบหรือทำลายข้อมูลส่วนบุคคลดังกล่าว
      จากการจัดเก็บหรือระบบของบริษัทฯ และของบุคคลอื่นซึ่งให้บริการแก่บริษัทฯ (ถ้ามี)
      หรือทำให้ข้อมูลส่วนบุคคลของท่านเป็นข้อมูลที่ไม่สามารถระบุตัวท่านได้
      เว้นแต่จะเป็นกรณีที่บริษัทฯ
      สามารถเก็บรักษาข้อมูลส่วนบุคคลดังกล่าวได้ต่อไปตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลหรือกฎหมายอื่นที่เกี่ยวข้องกำหนด
    </p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;11. สิทธิของเจ้าของข้อมูล</p>
    <p>
      สิทธิในส่วนนี้หมายถึงสิทธิตามกฎหมายที่เกี่ยวกับข้อมูลส่วนบุคคลของท่าน
      ซึ่งท่านอาจขอใช้สิทธิเหล่านี้กับบริษัทฯ
      ภายใต้เงื่อนไขที่กฎหมายกำหนดและกระบวนการจัดการสิทธิของบริษัทฯ
    </p>
    <br></br>
    <table id="specific-table">
      <thead>
        <tr>
          <th>สิทธิที่เกี่ยวกับข้อมูลส่วนบุคคล</th>
          <th>คำอธิบาย</th>
        </tr>
      </thead>
      <tbody>
        <tr className={stylesOne.lastRow}>
          <td>1. สิทธิในการเข้าถึงข้อมูลส่วนบุคคล</td>
          <td>
            ท่านมีสิทธิในการเข้าถึงข้อมูลส่วนบุคคลของท่านและขอให้บริษัทฯ
            ทำสำเนาข้อมูลส่วนบุคคลดังกล่าวให้แก่ท่าน ทั้งนี้
            ตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนด
          </td>
        </tr>

        <tr className={stylesOne.lastRow}>
          <td>2. สิทธิในการขอรับหรือขอให้ส่งหรือโอนข้อมูลส่วนบุคคล</td>
          <td>
            ท่านมีสิทธิในการขอรับหรือขอให้ส่งหรือโอนข้อมูลส่วนบุคคลของท่าน ในกรณีที่บริษัทฯ
            ได้ทำให้ข้อมูลส่วนบุคคลนั้นอยู่ในรูปแบบที่สามารถอ่านหรือใช้งานโดยทั่วไปได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติและสามารถใช้หรือเปิดเผยข้อมูลส่วนบุคคลได้ด้วยวิธีการอัตโนมัติ
            รวมทั้งมีสิทธิขอให้บริษัทฯ
            ส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคลภายนอกหรือขอรับข้อมูลส่วนบุคคลของท่านที่บริษัทฯ
            ส่งหรือโอนไปยังบุคคลภายนอก เว้นแต่บริษัทฯ
            ไม่สามารถดำเนินการดังกล่าวได้โดยสภาพทางเทคนิคไม่สามารถทำได้ หรือบริษัทฯ
            มีเหตุในการปฏิเสธคำขอของท่าน (เช่น
            เป็นการปฏิบัติหน้าที่เพื่อประโยชน์สาธารณะหรือเป็นการปฏิบัติหน้าที่ตามกฎหมาย
            หรือการใช้สิทธิในการขอรับหรือขอให้ส่งหรือโอนข้อมูลส่วนบุคคลนั้นจะเป็นการละเมิดต่อสิทธิหรือเสรีภาพของบุคคลอื่น)
          </td>
        </tr>

        <tr className={stylesOne.lastRow}>
          <td>3. สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล</td>
          <td>
            ท่านมีสิทธิในการขอคัดค้านการเก็บรวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคล
            ในกรณีที่มีการเก็บรวบรวม ใช้
            เปิดเผยข้อมูลส่วนบุคคลของท่านเนื่องจากความจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัทฯ
            หรือของบุคคลหรือนิติบุคคลอื่น
            หรือเพื่อปฏิบัติหน้าที่ในการดำเนินการตามภารกิจเพื่อสาธารณประโยชน์ ทั้งนี้ บริษัทฯ
            อาจปฏิเสธคำขอคัดค้านของท่านหากบริษัทฯ
            มีเหตุอันชอบด้วยกฎหมายที่สำคัญยิ่งกว่าหรือมีความจำเป็นต้องเก็บรวบรวม ใช้
            เปิดเผยข้อมูลเพื่อก่อตั้งสิทธิเรียกร้องตามกฎหมาย
            การปฏิบัติตามหรือการใช้สิทธิเรียกร้องตามกฎหมาย
            หรือการยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมาย
          </td>
        </tr>

        <tr className={stylesOne.lastRow}>
          <td>4. สิทธิในการลบข้อมูลส่วนบุคคล</td>
          <td>
            ท่านมีสิทธิขอให้บริษัทฯ
            ลบหรือทำลายข้อมูลส่วนบุคคลของท่านหรือทำให้ข้อมูลส่วนบุคคลนั้นเป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลได้
            อย่างไรก็ตาม บริษัทฯ อาจปฏิเสธคำขอของท่านหากบริษัทฯ
            มีเหตุโดยชอบด้วยกฎหมายในการเก็บข้อมูลส่วนบุคคลของท่านเพื่อปฏิบัติตามกฎหมาย
            หรือเพื่อการก่อตั้งสิทธิเรียกร้องตามกฎหมาย
            การปฏิบัติตามหรือการใช้สิทธิเรียกร้องตามกฎหมาย
            หรือการยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมาย
          </td>
        </tr>

        <tr className={stylesOne.lastRow}>
          <td>5. สิทธิในการระงับการใช้ข้อมูลส่วนบุคคล</td>
          <td>
            ท่านมีสิทธิขอให้บริษัทฯ
            ระงับการประมวลผลข้อมูลส่วนบุคคลของท่านในกรณีที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนด
          </td>
        </tr>

        <tr className={stylesOne.lastRow}>
          <td>6. สิทธิในการแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง</td>
          <td>
            ท่านมีสิทธิขอแก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้อง
            หากข้อมูลส่วนบุคคลของท่านนั้นไม่ถูกต้อง ไม่เป็นปัจจุบัน ไม่ครบถ้วนสมบูรณ์
            หรือก่อให้เกิดความเข้าใจผิด
          </td>
        </tr>

        <tr className={stylesOne.lastRow}>
          <td>7. สิทธิที่จะเพิกถอนความยินยอม</td>
          <td>
            ท่านมีสิทธิขอให้บริษัทฯ ระงับการใช้ข้อมูลส่วนบุคคลของท่านในบางกรณี เช่น เมื่อบริษัทฯ
            อยู่ในระหว่างการตรวจสอบคำขอใช้สิทธิให้แก้ไขข้อมูลส่วนบุคคลหรือคำขอคัดค้านการเก็บรวบรวม
            ใช้ เปิดเผยข้อมูลส่วนบุคคลของท่าน หรือในกรณีที่ท่านขอให้บริษัทฯ
            ระงับการใช้ข้อมูลส่วนบุคคลแทนการลบหรือหรือทำลาย
            หรือเมื่อข้อมูลส่วนบุคคลดังกล่าวหมดความจำเป็นแต่ท่านมีความจำเป็นต้องขอให้เก็บรักษาข้อมูลส่วนบุคคลของท่านไว้เพื่อใช้ในการก่อตั้งสิทธิเรียกร้องตามกฎหมาย
            การปฏิบัติตามหรือการใช้สิทธิเรียกร้องตามกฎหมาย
            หรือการยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมาย
            หรือท่านอาจะแจ้งร้องขอเกี่ยวกับข้อมูลส่วนบุคคลได้ที่ แบบคำร้องขอเกี่ยวกับข้อมูลส่วนบุคคล
          </td>
        </tr>

        <tr className={stylesOne.lastRow}>
          <td>8. สิทธิในการยื่นข้อร้องเรียน</td>
          <td>
            ท่านมีสิทธิในการร้องเรียนต่อคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล
            สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล หรือหน่วยงายรัฐอื่นที่มีอำนาจตามกฎหมาย
            หากท่านเชื่อว่าบริษัทฯ เก็บรวบรวม ใช้
            และ/หรือเปิดเผยข้อมูลส่วนบุคคลของท่านเป็นการกระทำในลักษณะที่ฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายที่เกี่ยวข้อง
          </td>
        </tr>

        <tr className={stylesOne.lastRow}>
          <td></td>
          <td>
            ทั้งนี้ บริษัทฯ ขอสงวนสิทธิในการพิจารณาคำร้องขอใช้สิทธิของท่าน โดยบริษัทฯ
            จะดำเนินการตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนดไว้
          </td>
        </tr>
      </tbody>
    </table>
    <br></br>
    <p>
      การใช้สิทธิของท่านหากท่านต้องการใช้สิทธิของเจ้าของข้อมูลส่วนบุคคลที่ระบุในส่วนนี้
      ท่านสามารถทำได้โดยส่งคำร้องขอผ่านช่องทางดังต่อไปนี้
    </p>
    <p>
      ส่งอีเมลถึงเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลที่ระบุในหัวข้อ “ช่องทางการติดต่อ”
      ท่านสามารถยื่นคำขอมายังบริษัทฯ โดยติดต่อตามช่องทางที่ระบุไว้ในข้อ 16.{' '}
    </p>
    <p>
      ก่อนดำเนินการตามคำขอใช้สิทธิของท่าน บริษัทฯ
      อาจมีความจำเป็นต้องขอข้อมูลของท่านเพิ่มเติมเพื่อดำเนินการยืนยันตัวตน ซึ่งอาจรวมถึง
      [ชื่อ-นามสกุล หมายเลขโทรศัพท์ อีเมล
      วันทำรายการล่าสุดและ/หรือวันล่าสุดที่ท่านมีปฏิสัมพันธ์กับบริษัทฯ
      และ/หรือหนังสือมอบอำนาจในกรณีที่เป็นนิติบุคคลหรือมอบหมายให้ผู้อื่นเป็นผู้ยื่นคำขอแทน] ทั้งนี้
      บริษัทฯ
      จะใช้ข้อมูลส่วนบุคคลดังกล่าวเพื่อการพิจารณาและดำเนินการตามคำขอใช้สิทธิของเจ้าของข้อมูลส่วนบุคคลเท่านั้น
    </p>
    <p>
      โปรดทราบว่า หากบริษัทฯ
      มีเหตุจำเป็นต้องปฏิเสธหรือไม่สามารถดำเนินการตามคำขอใช้สิทธิดังกล่าวข้างต้นของท่านตามที่กฎหมายกำหนด
      (เช่น เพื่อปฏิบัติตามกฎหมายหรือคำสั่งศาล เพื่อประโยชน์สาธารณะ
      หรือการใช้สิทธิของท่านอาจละเมิดสิทธิหรือเสรีภาพของบุคคลอื่น)
      บริษัทจะแจ้งเหตุแห่งการปฏิเสธให้ท่านได้ทราบด้วย
    </p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;11. คุกกี้ (Cookies)</p>
    <p>
      เมื่อท่านเยี่ยมชมหรือใช้งานผลิตภัณฑ์และ/หรือบริการบนเว็บไซต์ของบริษัทฯ บริษัทฯ
      จะเก็บรวบรวมบันทึกการเข้าใช้งานเว็บไซต์ของท่านอัตโนมัติโดยการใช้คุกกี้และเทคโนโลยีอื่นที่คล้ายกันเพื่อวิเคราะห์การทำงานและปัญหาทางเทคนิคของเว็บไซต์
      เพื่อตอบสนองการใช้งานเว็บไซต์และส่งมอบประสบการณ์ใช้งานเว็บไซต์ที่ดีให้แก่ท่าน
      และเพื่อติดตามข้อมูลการใช้งานเว็บไซต์ของท่าน
      ข้อมูลที่ถูกจัดเก็บเหล่านี้จะถูกนำไปเพื่อจุดประสงค์ในการพัฒนาและปรับปรุงเว็บไซต์ของบริษัทฯ
      ให้ตรงกับความต้องการของท่านมากยิ่งขึ้น
      การปิดการใช้งานคุกกี้และเทคโนโลยีอื่นที่คล้ายกันอาจส่งผลให้ฟีเจอร์บางอย่างของเว็บไซต์ไม่สามารถทำงานได้
      โปรดศึกษารายละเอียดเพิ่มเติมเกี่ยวกับการใช้คุกกี้และเทคโนโลยีอื่นที่คล้ายกันของบริษัทฯ
      และวิธีการตั้งค่าหรือปิดการใช้งานคุกกี้ใน นโยบายการใช้คุกกี้ (Cookie Policy){' '}
    </p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;12. ข้อมูลขยะ สแปม สปายแวร์ ไวรัส</p>
    <p>
      ข้อมูลขยะ (Spam) สปายแวร์ (Spyware) หรือ ไวรัส (Virus)
      นั้นไม่ได้รับอนุญาตบนแพลตฟอร์มของบริษัทฯ ห้ามมีการส่งข้อความใด ๆ ที่มีข้อมูลขยะ สปายแวร์
      หรือไวรัส ผ่านทางแพลตฟอร์มอีคอมเมอร์ส หากท่านต้องการรายงานข้อความที่น่าสงสัยให้
      กรุณาติดต่อผ่านทางอีเมลตามที่ระบุในข้อ 16.{' '}
    </p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;13. การบันทึกข้อมูล</p>
    <p>
      ผู้ควบคุมข้อมูลส่วนบุคคลจะบันทึกรายการสำคัญเป็นหนังสือหรือระบบอิเล็กทรอนิกส์เพื่อการตรวจสอบจากเจ้าของข้อมูลหรือจากหน่วยงานของรัฐ
      อันรวมถึงแต่ไม่จำกัดเพียงรายการ ดังต่อไปนี้
    </p>
    <p>ข้อมูลส่วนบุคคลที่มีการเก็บรวบรวม</p>
    <p>วัตถุประสงค์ของการเก็บรวบรวมข้อมูลส่วนบุคคลแต่ละประเภท</p>
    <p>ข้อมูลเกี่ยวกับผู้ควบคุมข้อมูลส่วนบุคคล</p>
    <p>ระยะเวลาการเก็บรักษาข้อมูลส่วนบุคคล</p>
    <p>
      สิทธิและวิธีการเข้าถึงข้อมูลส่วนบุคคล
      รวมทั้งเงื่อนไขเกี่ยวกับบุคคลที่มีสิทธิเข้าถึงข้อมูลส่วนบุคคลและเงื่อนไขในการเข้าถึงข้อมูลส่วนบุคคลนั้น
    </p>
    <p>
      การเก็บรวบรวม ใช้
      หรือเปิดเผยข้อมูลส่วนบุคคลที่ได้รับยกเว้นไม่ต้องขอความยินยอมจากผู้ใช้งานเจ้าของข้อมูล
    </p>
    <p>การปฏิเสธคำขอและการคัดค้านต่าง ๆ</p>
    <p>รายละเอียดเกี่ยวกับมาตรการรักษาความมั่นคงปลอดภัยในข้อมูลส่วนบุคคล</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;14. ขอบเขตของประกาศเกี่ยวกับคุ้มครองข้อมูลส่วนบุคคล</p>
    <p>
      ประกาศเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ ใช้เฉพาะการให้บริการของบริษัทฯ เท่านั้น
      ในกรณีที่ท่านเชื่อมต่อไปยังแพลตฟอร์มของบริษัทอื่น
      แม้จะเป็นการเชื่อมต่อผ่านลิงก์ที่อยู่ในเว็บไซต์ของบริษัทฯ ก็ตาม
      นโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้จะไม่มีผลผูกพัน
      ท่านจำเป็นต้องศึกษาและปฏิบัติตามนโยบายคุ้มครองข้อมูลส่วนบุคคลที่ปรากฏบนแพลตฟอร์มเหล่านั้น
      และบริษัทฯ จะไม่รับผิดชอบเกี่ยวกับการดำเนินการต่าง ๆ ของแพลตฟอร์มอื่นนั้นทั้งสิ้น
    </p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;15. การเปลี่ยนแปลงนโยบายคุ้มครองข้อมูลส่วนบุคคล</p>
    <p>
      บริษัทฯ อาจเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราวและตามที่กฎหมายอนุญาต โดยบริษัทฯ
      จะแจ้งการเปลี่ยนแปลงกล่าวบนเว็บไซต์ของบริษัทฯ
      โดยนโยบายความเป็นส่วนตัวที่แก้ไขนี้จะมีผลใช้บังคับในวันที่บริษัทฯ เผยแพร่บนเว็บไซต์ดังกล่าว
      บริษัทฯ แนะนำให้ท่านตรวจสอบนโยบายความเป็นส่วนตัวนี้เป็นประจำ
      โดยการที่ท่านใช้ผลิตภัณฑ์หรือบริการทางเว็บไซต์ของบริษัทฯ
      ต่อไปหลังจากที่มีการเปลี่ยนแปลงนโยบายความเป็นส่วนตัว
      จะถือว่าท่านยอมรับนโยบายที่เปลี่ยนแปลงนั้นแล้ว
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;16. ช่องทางการติดต่อบริษัทฯ
      และเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
    </p>
    <p>
      หากท่านมีข้อสงสัยเกี่ยวกับแนวปฏิบัติการเก็บรวบรวม ใช้
      เปิดเผยและ/หรือโอนไปซึ่งข้อมูลส่วนบุคคลของบริษัทฯ
      หรือต้องการใช้สิทธิตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล ท่านสามารถติดต่อสอบถามได้ที่{' '}
    </p>
    <p>16.1 ผู้ควบคุมข้อมูลส่วนบุคคล</p>
    <p>บริษัท ร้านร่าเริง จำกัด</p>
    <p>เลขที่ 123/1 ถนนนนทรี แขวงช่องนนทรี เขตยานนาวา กรุงเทพมหานคร 10120 โทร 09 5319 4700</p>
    <p>อีเมล์ applehouse.mkt@gmail.com</p>
    <p>16.2 เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data Protection Officer: DPO)</p>
    <p>บริษัท ร้านร่าเริง จำกัด</p>
    <p>เลขที่ 123/1 ถนนนนทรี แขวงช่องนนทรี เขตยานนาวา กรุงเทพมหานคร 10120 โทร 09 5319 4700</p>
    <p>อีเมล์ applehouse.mkt@gmail.com </p>
  </div>
);
